import { User } from '@/modules/authentication/models/user';
import { RequestStatusEnum } from '@/modules/analysis/models/requestStatusEnum';

export function emptyRequest(): AnalysisRequest {
  return {
    subject: {
      locationId: '',
      budgetLineId: '',
      reason: '',
      laboratoryName: '',
      description: '',
      resSubmissionDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10)
    },
    sampleBatches: []
  };
}
export interface AnalysisRequest {
  id?: string;
  createdAt?: Date;
  extRefId?: string;
  applicant?: User;
  resultsFiles?: ResultFile[];
  currentStatus?: string;
  subject: AnalysisRequestSubject;
  sampleBatches: SampleBatch[];
  facts?: FactAnalysisRequest[];
  chatMessages?: ChatMessage[];
}

export interface ChatMessage {
  createdAt: Date;
  content: string;
  actor: User;
}

export interface FactAnalysisRequest {
  createdAt: Date;
  status: RequestStatusEnum;
  actor: User;
}

export interface AnalysisRequestSubject {
  locationId: string;
  budgetLineId: string;
  reason: string;
  laboratoryName: string;
  description: string;
  resSubmissionDate: string;
}

export interface SampleBatch {
  id?: string;
  analyzes: Analyzes;
  nature: null | string;
  count: null | number;
  samples: Sample[];
  analysisId?: null | string;
  countFinished?: number;
  countReceived?: number;
  isFinished?: boolean;
  isAwaitingSamples?: boolean;
  analysisCurrentStatus?: string;
}

export interface GammaSpecRnValue {
  isActive?: boolean;
  label: string;
  detectionMode: string;
  value: string;
  detectionUnit: string;
}

export interface RadiochemRnValue {
  isActive?: boolean;
  label: string;
  value: string;
  detectionMode: string;
  detectionUnit: string;
}

export interface Analyzes {
  gammaScan: boolean;
  gammaScanTimeValue: number;
  gammaSpec: boolean;
  gammaSpecType: string;
  gammaSpecTimeValue: number;
  gammaSpecRnValue: GammaSpecRnValue[];
  radiochem: boolean;
  radiochemRnValue: RadiochemRnValue[];
  alphaEmitters: boolean;
  betaEmitters: boolean;
  strontium: boolean;
}

export interface Sample {
  id?: string;
  barcode?: string;
  reference: string;
  origin: string;
  size: string;
  sizeUnit: string;
  samplingDate: string;
  facts?: FactSample[];
  steps?: StepSample[][];
}

export interface StepSample {
  status: string;
  value: boolean;
  isNew: boolean;
}

export interface FactSample {
  createdAt?: Date;
  status: string;
  actor?: User;
}

export interface ResultFile {
  id?: string;
  createdAt: Date;
  published: boolean;
  fileName: string;
  mimetype: string;
  md5: string;
  data: Buffer;
}
